import PublicRoutes from './PublicRoutes';
import PrivateRoutes from './PrivateRoutes';
import { useSelector } from 'react-redux';
import AdditionalPublicRoutes from './AdditionalPublicRoutes';
import { useLocation } from 'react-router-dom';

const Routes = () => {
  const { user } = useSelector(({ auth }) => auth);
  const { pathname } = useLocation();
  function getRouteStatus() {
    const pathArr = ['/generate-password', '/reset-success', '/email-verified', '/payment-success', '/payment-cancelled'];
    if (pathArr.includes(pathname?.toLowerCase())) {
      return true;
    }
    return false;
  }

  if (getRouteStatus()) {
    return <AdditionalPublicRoutes />
  } else {
    if (user?.accessToken) {
      return <PrivateRoutes />
    } else {
      return <PublicRoutes />
    }
  }
}

export default Routes;